import { ReactNode } from "react";
import "./box-content.scss";
import { formatMoney } from "../../procedure/util";

interface BoxContentProps {
  children: ReactNode;
  color?: "primary" | "success" | "info" | "warning" | "danger" | "more-danger";
  background?: "bg-user" | "bg-approver";
  style?: React.CSSProperties;
  onClick?: () => void;
}
const BoxContent = ({ children, color = "primary", background = "bg-user", style, onClick }: BoxContentProps) => {
  return <div onClick={onClick} role="button" className={`box-content ${color} ${background}`} style={style}>{children}</div>;
};

BoxContent.Icon = ({ src }: { src: string }) => {
  return <img src={src} alt=" " />;
};

BoxContent.Label = ({ children }: { children: ReactNode }) => {
  return <h4>{children}</h4>;
};

BoxContent.Count = ({ value }: { value: number }) => {
  return <p>{formatMoney(value)}</p>;
};

BoxContent.Right = ({ children }: { children: ReactNode }) => {
  return <div className="box-content--right">{children}</div>;
};

export default BoxContent;
